import { useEffect } from 'react';
import { useStarGridData } from '../context/StarGridDataContext';
import { isResourcePending } from './useAsyncResource';
import { StarGridHealth } from '../starGridTypes';

export interface UseStarGridHealthResult {
  health: StarGridHealth | undefined;
  loading: boolean;
  error: string | undefined;
  refresh: () => void;
}

/**
 * StarGrid API health, backed by the shared StarGridDataProvider so it is fetched once and cached
 * across navigation. Loads lazily on first mount.
 */
export function useStarGridHealth(): UseStarGridHealthResult {
  const { health } = useStarGridData();
  const { ensureLoaded, data, error, refresh } = health;

  useEffect(() => {
    ensureLoaded();
  }, [ensureLoaded]);

  return { health: data, loading: isResourcePending(health), error, refresh };
}
